import { useEffect, useState } from 'react';
import { usePageTitle } from '../../hooks/usePageTitle';
import SideBar from '../../components/global/SideBar';
import './index.css';
import SpecialistPage from '../../components/specialists/SpecialistPage';
import { Loader } from '@beholos/holoscommon';
import type { PartnerResponse } from '../../services/schedule.service';
import { fetchPartnersOfType } from '../../services/specialist.service';

export default function Psychology() {
  usePageTitle('Psicología - Holos');
  const [partners, setPartners] = useState<PartnerResponse[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchData = async () => {
      setPartners(await fetchPartnersOfType('showPsychologist'));
      setLoading(false);
    }
    fetchData();
  }, [])

  return (
    <div className="flex h-[calc(100vh-80px)] w-screen overflow-hidden">
      <div className="hidden md:block md:w-80 lg:w-96 h-full overflow-y-auto">
        <SideBar />
      </div>

      <div className="flex-1 h-full overflow-y-auto">
        {loading ? <Loader /> : <SpecialistPage
          bannerClassName="md:min-h-[auto] min-h-[calc(100vh-80px)]"
          banner={{
            title: 'Sesiones con Psicólogos especialistas',
            subtitle:
              'Estas sesiones podrán ayudarte a sobrellevar tu salud mental, controlar situaciones estresantes y a eliminar los obstáculos que te impiden alcanzar tus objetivos.',
            imageUrl:
              'https://cache.beholos.com/img/fitness-pass-v2/life/psychology/banner.jpg',
            links: {
              text: 'Agendar Sesión',
              to: 'reservar',
            },
          }}
          icons={[
            {
              icon: 'life/psychology/icon-1.svg',
              title: 'Asesoramiento Personalizado',
              detail:
                'Nuestra comunidad de profesionales psicoterapeutas, psicólogos y consejeros están listos para ayudarte.',
              height: 60,
            },
            {
              icon: 'life/psychology/icon-2.svg',
              title: 'Rapidez y Flexibilidad',
              detail:
                'Agenda tu sesión con solo un clic según tu disponibilidad y preferencia.',
              height: 60,
            },
            {
              icon: 'life/psychology/icon-3.svg',
              title: 'Confidencialidad',
              detail:
                'Garantizamos la seguridad de tu información personal.',
              height: 60,
            },
          ]}
          psychologyLearn={{
            title: 'Hoy decido estar bien',
            subtitle: 'Un psicólogo asesora positivamente y mejora la calidad de vida del usuario en sus principales aspectos. Agenda una sesión y recibe acompañamiento psicológico a tu medida.',
            topics: [
              { icon: 'pyshcology-help-icon-1.svg', title: 'Orientación vocacional' },
              { icon: 'pyshcology-help-icon-2.svg', title: 'Autoestima' },
              { icon: 'pyshcology-help-icon-3.svg', title: 'Duelos' },
              { icon: 'pyshcology-help-icon-4.svg', title: 'Enfrentando el covid-19' },
              { icon: 'pyshcology-help-icon-5.svg', title: 'Depresión' },
              { icon: 'pyshcology-help-icon-6.svg', title: 'Vínculos familiares' },
              { icon: 'pyshcology-help-icon-7.svg', title: 'Bienestar' },
              { icon: 'pyshcology-help-icon-8.svg', title: 'Ansiedad' },
              { icon: 'pyshcology-help-icon-9.svg', title: 'Crianza' },
              { icon: 'pyshcology-help-icon-10.svg', title: 'Crisis' },
              { icon: 'pyshcology-help-icon-11.svg', title: 'Estrés' },
              { icon: 'pyshcology-help-icon-12.svg', title: 'Toma de decisiones' },
            ]
          }}
          section={{
            title: 'Conoce a nuestros profesionales',
            description:
              'El entregable son tareas personalizadas que se dejan en la sesión directamente entre el usuario y el profesional.',
          }}
          specialists={partners.map(partner => ({
            id: partner._id,
            name: partner.name,
            slug: partner.slug,
            imageUrl: `https://image.beholos.com/600x500/filters:quality(90)${partner.otherStudioImages[0]}`,
            countryImageUrl: `https://cache.beholos.com${partner.country?.image}`,
            type: 'Psicólogo'
          }))}
          howToSchedule={{
            title: '¿Cómo agendar una sesión de psicología?',
            steps: [
              {
                number: 1,
                title: 'Escoge tu especialista',
                description: 'Revisa el staff de especialistas que puedan ayudarte según tu necesidad.'
              },
              {
                number: 2,
                title: 'Agenda y confirma la fecha',
                description: 'Escoge fácilmente la fecha en la cual quieres agendar tu sesión con mínimo 48 horas. ¡La confirmas con un clic!'
              },
              {
                number: 3,
                title: 'Lleva a cabo la sesión',
                description: 'Según la hora confirmada, recibirás un enlace para conectarte e iniciar la sesión.'
              }
            ]
          }}
          article={{
            title: 'Aprende más de salud mental',
            subTitle: 'Encuentra el equilibrio entre tu vida laboral y tus relaciones personales para alcanzar una mejor calidad de vida.',
          }}
        />}
      </div>
    </div>
  );
}
